export const SAVE_INDICATOR_INCREMENT_COUNT = "saveIndicatorIncrementCount";
export const SAVE_INDICATOR_DECREMENT_COUNT = "saveIndicatorDecrementCount";
export const SAVE_INDICATOR_SET_SUCCESS = "saveIndicatorSetSuccess";

const state = {
  saveIndicator: {
    count: 0,
    success: false,
  },
};

const actions = {
  [SAVE_INDICATOR_INCREMENT_COUNT]({ commit }) {
    commit(SAVE_INDICATOR_INCREMENT_COUNT);
  },
  [SAVE_INDICATOR_DECREMENT_COUNT]({ commit }) {
    commit(SAVE_INDICATOR_DECREMENT_COUNT);
  },
  [SAVE_INDICATOR_SET_SUCCESS]({ commit }, value) {
    commit(SAVE_INDICATOR_SET_SUCCESS, value);
  },
};

const mutations = {
  [SAVE_INDICATOR_INCREMENT_COUNT](state) {
    ++state.saveIndicator.count;
  },
  [SAVE_INDICATOR_DECREMENT_COUNT](state) {
    --state.saveIndicator.count;
  },
  [SAVE_INDICATOR_SET_SUCCESS](state, value) {
    state.saveIndicator.success = value;
  },
};

const getters = {
  saveIndicator: (state) => state.saveIndicator,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
